import { render, staticRenderFns } from "./widgetSuggestion.vue?vue&type=template&id=4b852306&scoped=true&"
import script from "./widgetSuggestion.vue?vue&type=script&lang=js&"
export * from "./widgetSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./widgetSuggestion.vue?vue&type=style&index=0&id=4b852306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b852306",
  null
  
)

export default component.exports